import { render, staticRenderFns } from "./PunchAttendance.vue?vue&type=template&id=5b77eee9&scoped=true&"
import script from "./PunchAttendance.vue?vue&type=script&lang=js&"
export * from "./PunchAttendance.vue?vue&type=script&lang=js&"
import style0 from "./PunchAttendance.vue?vue&type=style&index=0&id=5b77eee9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b77eee9",
  null
  
)

export default component.exports